{
    "upload_company_logo": "Zulässige Dateien: alle Bilddateien.",
    "upload_profile_picture": "Zulässige Dateien: alle Bilddateien."
}
